import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (url: string) => {
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section id="category-dropdown" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
            Kategorie
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Wybierz kategorię produktów
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Skorzystaj z rozwijanego menu, aby szybko przejść do interesującej Cię kategorii na głównej platformie Kakobuy Spreadsheet.
          </p>
        </div>

        <div ref={dropdownRef} className="relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-4 bg-background-100 border-2 border-background-200 rounded-xl text-foreground-800 font-medium cursor-pointer hover:border-primary-300 transition-all"
          >
            <span className="flex items-center gap-3">
              <i className="ri-menu-search-line text-primary-500 text-lg"></i>
              <span className="text-sm md:text-base">Wybierz kategorię, aby przejść do Kakobuy Spreadsheet...</span>
            </span>
            <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 transition-transform duration-200`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-lg z-40 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat.url)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <span className="w-8 h-8 flex items-center justify-center bg-secondary-100 rounded-lg flex-shrink-0">
                    <i className={`${cat.icon} text-secondary-600`}></i>
                  </span>
                  <span className="font-medium">{cat.name}</span>
                  <i className="ri-arrow-right-line text-foreground-400 ml-auto"></i>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}